<template>
  <v-dialog v-model="dialog" max-width="40%">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" color="primary">
        <v-icon icon>delete</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Delete Shipment Line Item
      </v-card-title>
      <v-card-text>
        Deleting this line item cannot be undone. Are you sure??!
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="close" color="primary">
          <v-icon left small>close</v-icon>
          Close
        </v-btn>
        <v-btn @click="del" color="error">
          <v-icon left small>delete</v-icon>
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ShippingLineItemDelete",
  props: {
    instance: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    del() {
      this.instance.constructor
        .$delete(this.instance.id)
        .then(() => this.close());
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
